import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e33996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "good-road-item-root" }
const _hoisted_2 = { class: "good-road-item-header" }
const _hoisted_3 = { class: "table-name" }
const _hoisted_4 = { class: "limit-info" }
const _hoisted_5 = ["data-tooltip"]
const _hoisted_6 = { class: "road-map-content" }
const _hoisted_7 = {
  key: 0,
  class: "card-result-overlay"
}
const _hoisted_8 = { class: "hand-meta" }
const _hoisted_9 = { class: "hand-label" }
const _hoisted_10 = { class: "hand-point" }
const _hoisted_11 = { class: "hand-cards" }
const _hoisted_12 = ["data-color"]
const _hoisted_13 = { class: "hand-meta" }
const _hoisted_14 = { class: "hand-label" }
const _hoisted_15 = { class: "hand-point" }
const _hoisted_16 = { class: "hand-cards" }
const _hoisted_17 = { class: "box-content player-side" }
const _hoisted_18 = { class: "box-content banker-side" }
const _hoisted_19 = {
  key: 0,
  class: "box-content button-group"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "toast-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map = _resolveComponent("road-map")!
  const _component_good_road_bet_box = _resolveComponent("good-road-bet-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tableLimit), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["timer-or-status", { 'no-bet': _ctx.betTime < 0 }])
      }, _toDisplayString(_ctx.timerLabel), 3),
      (_ctx.mData?.goodRoadName)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "good-road-name",
            "data-tooltip": _ctx.mData.goodRoadName
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.mData.goodRoadName), 1)
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_road_map, {
        style: {"width":"100%","height":"100%"},
        "map-data": _ctx.mData?.table.expand.resultList || [],
        "bead-row-count": 6,
        display: _ctx.deviceOrientation === 'landscape' ? 0 : 2,
        "game-type": _ctx.mData?.table?.gameTypeNo?.toUpperCase() === 'G002' ? 1 : 2
      }, null, 8, ["map-data", "display", "game-type"]),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (_ctx.showCardResult && _ctx.cardResultSnapshot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["hand-side red", { win: _ctx.isRedWin }])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.redLabel), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.cardResultSnapshot.redTotal), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redCardsDisplay, (card, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `r-${index}-${card.code}`,
                        class: _normalizeClass(["card-slot", { third: card.isThird }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card", _ctx.cardClass(card.code, card.isThird)])
                        }, null, 2)
                      ], 2))
                    }), 128))
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: "result-label",
                  "data-color": _ctx.winnerColor
                }, _toDisplayString(_ctx.resultLabel), 9, _hoisted_12),
                _createElementVNode("div", {
                  class: _normalizeClass(["hand-side blue", { win: _ctx.isBlueWin }])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.blueLabel), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.cardResultSnapshot.blueTotal), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blueCardsDisplay, (card, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `b-${index}-${card.code}`,
                        class: _normalizeClass(["card-slot", { third: card.isThird }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card", _ctx.cardClass(card.code, card.isThird)])
                        }, null, 2)
                      ], 2))
                    }), 128))
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["betting-group", { 'is-dragon-tiger': _ctx.gameTypeNo !== 'G002' }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_good_road_bet_box, {
          ref: "playerBetBox",
          betlabel: _ctx.gameTypeNo === 'G002' ? '闲' : '虎',
          betRatio: "1:1",
          "total-bet": _ctx.playerTotal,
          color: "blue",
          "m-width": _ctx.betBoxMWidth,
          "m-height": _ctx.betBoxMHeight,
          "bet-type": _ctx.BetType.PLAYER,
          "temp-bet": _ctx.tempPBet,
          "confirmed-bet": _ctx.pBet,
          onPlaceBet: _ctx.placeBet,
          width: 100,
          height: 48
        }, null, 8, ["betlabel", "total-bet", "m-width", "m-height", "bet-type", "temp-bet", "confirmed-bet", "onPlaceBet"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_good_road_bet_box, {
          ref: "bankerBetBox",
          betlabel: _ctx.gameTypeNo === 'G002' ? '庄' : '龙',
          betRatio: _ctx.redBetRatio,
          "total-bet": _ctx.bankerTotal,
          color: "red",
          "bet-type": _ctx.BetType.BANKER,
          "temp-bet": _ctx.tempBBet,
          "confirmed-bet": _ctx.bBet,
          onPlaceBet: _ctx.placeBet,
          "m-width": _ctx.betBoxMWidth,
          "m-height": _ctx.betBoxMHeight,
          width: 100,
          height: 48
        }, null, 8, ["betlabel", "betRatio", "total-bet", "bet-type", "temp-bet", "confirmed-bet", "onPlaceBet", "m-width", "m-height"])
      ]),
      (_ctx.allowBet && !_ctx.isBetOnProcess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "cancel-button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelTempBet && _ctx.cancelTempBet(...args)), ["stop"]))
            }, _hoisted_21),
            _createElementVNode("div", {
              class: "confirm-button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmTempBet && _ctx.confirmTempBet(...args)), ["stop"]))
            }, _hoisted_23)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_TransitionGroup, {
          class: "toast-container",
          tag: "div",
          name: "list",
          appear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastMessage, (toast, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "toast",
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(toast.message), 1)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}